module.exports = __webpack_public_path__ + "static/media/competenzlab.4749665e.webp";